/**
 * Copyright 2016 xdot GmbH
 *
 * Author: Marius Runde
 * Date: 19.07.2016
 *
 */
'use strict';
import L from 'external/leaflet';
import { amdRequire } from 'plugin/liferay-widgets-react-web';

const expandIcon = '<span class="fa fa-expand"/>';
const collapseIcon = '<span class="fa fa-compress"/>';

const FULLSCREEN_CLASS = 'map-fullscreen';

export default class FullscreenPlugin {

    constructor(props) {
        this.onEscape = this.onEscape.bind(this);
        this.init = this.init.bind(this);
    }

    init(map, o) {
        amdRequire([ 'leaflet.fullscreen', 'css!leaflet.fullscreen-css' ], () => {
            this.control = L.control.fullscreen({
                position: 'topright',
                title: 'Vollbild öffnen',
                titleCancel: 'Vollbild schließen',
                content: expandIcon,
                forcePseudoFullscreen: true
            });
            map.addControl(this.control);

            map.on('enterFullscreen', () => {
                map.invalidateSize();
                this.control.link.innerHTML = collapseIcon;
                map.gestureHandling.disable();
                document.addEventListener('keyup', this.onEscape);
                document.body.classList.add(FULLSCREEN_CLASS);
            });

            map.on('exitFullscreen', () => {
                map.invalidateSize();
                this.control.link.innerHTML = expandIcon;
                map.gestureHandling.enable();
                document.removeEventListener('keyup', this.onEscape);
                document.body.classList.remove(FULLSCREEN_CLASS);
            });
        });
    }

    onEscape(e) {
        if (e.keyCode === 27) {
            this.control.toggleFullScreen();
        }
    }

}



// WEBPACK FOOTER //
// ./js/plugins/FullscreenPlugin.js